import { render, staticRenderFns } from "./myReward.vue?vue&type=template&id=29cf43e2&scoped=true"
import script from "./myReward.vue?vue&type=script&lang=js"
export * from "./myReward.vue?vue&type=script&lang=js"
import style0 from "./myReward.vue?vue&type=style&index=0&id=29cf43e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf43e2",
  null
  
)

export default component.exports